import { type QSetConditionsTags } from '@exam-management/graphql';

const CALCULATION_LABEL = {
  ['คำนวณ']: 'คำนวณ',
  ['ไม่คำนวณ']: 'ไม่คำนวณ',
};

export function formatQuestionCalculationTags(tags: QSetConditionsTags[]) {
  const formattedTags = Object.keys(CALCULATION_LABEL).map((calculation) => {
    const count = tags.find((tag) => tag.tag.name === calculation)?.count;
    return `${calculation}: ${count ?? '-'} ข้อ`;
  });

  return formattedTags.length ? formattedTags.join(', ') : '-';
}
